import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
  Navigate,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "./i18n"; // your i18n config

import HomeScreen from "./HomeScreen";
import ScreenContainer from "./ScreenContainer";
import DresscodeSection from "./Dresscode";
import ThingsToDo from "./ThingsToDo";
import WhatToBring from "./WhatToBring";
import WhatsCovered from "./WhatsCovered";

function LanguageWrapper({ children }: { children: React.ReactNode }) {
  const { lang } = useParams(); // Get lang from URL param
  const { i18n: i18nextInstance } = useTranslation();

  useEffect(() => {
    if (lang && (lang === "en" || lang === "cs")) {
      i18nextInstance.changeLanguage(lang);
    } else {
      i18nextInstance.changeLanguage("en");
    }
  }, [lang, i18nextInstance]);

  // If language param is not 'en' or 'cs', redirect to default 'en'
  if (lang && lang !== "en" && lang !== "cs") {
    return <Navigate to="/en" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <Router>
      <ScreenContainer>
        <Routes>
          <Route path="/" element={<Navigate to="/en" replace />} />
          <Route
            path="/:lang"
            element={
              <LanguageWrapper>
                <HomeScreen />
              </LanguageWrapper>
            }
          />
          <Route
            path="/:lang/dresscode"
            element={
              <LanguageWrapper>
                <DresscodeSection />
              </LanguageWrapper>
            }
          />
          <Route
            path="/:lang/what-to-do"
            element={
              <LanguageWrapper>
                <ThingsToDo />
              </LanguageWrapper>
            }
          />
          <Route
            path="/:lang/what-to-bring"
            element={
              <LanguageWrapper>
                <WhatToBring />
              </LanguageWrapper>
            }
          />
          <Route
            path="/:lang/whats-covered"
            element={
              <LanguageWrapper>
                <WhatsCovered />
              </LanguageWrapper>
            }
          />
        </Routes>
      </ScreenContainer>
    </Router>
  );
}
